// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Components
import './components/sliders.js';
import { servicesSlider, stepsSlider } from './components/sliders.js';
import './components/accordions.js';
import './components/popup.js';
import './components/aos-init.js';
import './components/services-animation.js';
import './components/hero-simple.js';
import './components/two-blocks.js';

// Custom JavaScript will go here

// Helper function to check if device is desktop
function isDesktop() {
    return window.matchMedia('(min-width: 1025px)').matches;
}

// Header fixed on scroll
document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    if (!header) return;
    
    let headerHeight = header.offsetHeight;
    
    // Обновляем высоту header при ресайзе
    window.addEventListener('resize', function() {
        headerHeight = header.offsetHeight;
    });
    
    // Добавляем/удаляем класс is-fixed при скролле
    window.addEventListener('scroll', function() {
        if (window.scrollY > headerHeight) {
            header.classList.add('is-fixed');
        } else {
            header.classList.remove('is-fixed');
        }
    });
});

// Helper function to check if device is mobile
function isMobileDevice() {
    // Комбинированная проверка: размер экрана + touch support
    return window.matchMedia('(max-width: 1024px)').matches || 
           ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0);
}

// Helper function to get animation parameters based on device
function getAnimationParams() {
    const isMobile = !isDesktop();
    return {
        scrollTriggerStart: isMobile ? "top 80%" : "top 60%",
        offsetY: isMobile ? 40 : 80,
        offsetYSmall: isMobile ? 30 : 60,
        duration: isMobile ? 0.9 : 1.3,
        durationShort: isMobile ? 0.7 : 1.04
    };
}

// Mobile menu animations
document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuClose = document.querySelector('.mobile-menu-close');
    
    if (!mobileMenuButton || !mobileMenu || !mobileMenuClose) return;
    
    // Set initial state
    gsap.set(mobileMenu, {
        opacity: 0,
        y: -window.innerHeight,
        pointerEvents: 'none'
    });
    
    // Open mobile menu animation
    function openMobileMenu() {
        mobileMenu.classList.add('active');
        
        gsap.to(mobileMenu, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            pointerEvents: 'auto',
            onComplete: () => {
                mobileMenu.style.pointerEvents = 'auto';
            }
        });
        
        // Animate menu items with stagger
        const menuItems = mobileMenu.querySelectorAll('.mobile-menu-languages-item, .mobile-menu-menu-item');
        gsap.fromTo(menuItems,
            {
                opacity: 0,
                y: 30
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.1,
                delay: 0.2,
                ease: "power3.out"
            }
        );
    }
    
    // Close mobile menu animation
    function closeMobileMenu() {
        const menuItems = mobileMenu.querySelectorAll('.mobile-menu-languages-item, .mobile-menu-menu-item');
        
        gsap.to(menuItems, {
            opacity: 0,
            y: -30,
            duration: 0.3,
            stagger: 0.05,
            ease: "power3.in"
        });
        
        gsap.to(mobileMenu, {
            opacity: 0,
            y: -window.innerHeight,
            duration: 0.4,
            ease: "power3.in",
            pointerEvents: 'none',
            delay: 0.1,
            onComplete: () => {
                mobileMenu.classList.remove('active');
                mobileMenu.style.pointerEvents = 'none';
            }
        });
    }
    
    // Event listeners
    mobileMenuButton.addEventListener('click', openMobileMenu);
    mobileMenuClose.addEventListener('click', closeMobileMenu);
    
    // Close menu when clicking outside
    mobileMenu.addEventListener('click', (e) => {
        if (e.target === mobileMenu) {
            closeMobileMenu();
        }
    });
});

// // Handle window resize to enable/disable animations
// window.addEventListener('resize', function() {
//     const desktop = isDesktop();
    
//     // Kill all GSAP animations on mobile/tablet
//     if (!desktop) {
//         gsap.killTweensOf("*");
//     }
// });

// Gradient pulse animations for all sections (desktop only)
document.addEventListener('DOMContentLoaded', function() {
    // Check if device is desktop (wider than tablet)
    console.log('Gradient animations - isDesktop:', isDesktop());
    
    if (!isDesktop()) return; // Skip animations on tablets and mobile
    
    // Hero gradient pulse animation
    const heroGradient = document.querySelector('.hero-gradient');
    if (heroGradient) {
        gsap.to(heroGradient, {
            scale: 1.6,
            duration: 2,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // Features gradient pulse animation
    const featuresGradient = document.querySelector('.features-gradient');
    if (featuresGradient) {
        gsap.to(featuresGradient, {
            scale: 1.55,
            duration: 2.5,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // Services gradient pulse animation
    const servicesGradient = document.querySelector('.services-gradient');
    if (servicesGradient) {
        gsap.to(servicesGradient, {
            scale: 1.65,
            duration: 3,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // Testimonials gradient pulse animation
    const testimonialsGradient = document.querySelector('.testimonials-gradient');
    if (testimonialsGradient) {
        gsap.to(testimonialsGradient, {
            scale: 1.5,
            duration: 2.2,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // Tariffs gradient pulse animation
    const tariffsGradient = document.querySelector('.tariffs-gradient');
    if (tariffsGradient) {
        gsap.to(tariffsGradient, {
            scale: 1.58,
            duration: 2.8,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // Steps gradient pulse animation
    const stepsGradient = document.querySelector('.steps-gradient');
    if (stepsGradient) {
        gsap.to(stepsGradient, {
            scale: 1.62,
            duration: 2.4,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
    
    // FAQ gradient pulse animation
    const faqGradient = document.querySelector('.faq-gradient');
    if (faqGradient) {
        gsap.to(faqGradient, {
            scale: 1.52,
            duration: 2.6,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });
    }
});

// Hero scroll animations
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip GSAP animations on mobile - using AOS instead
    
    const heroSection = document.querySelector('.hero');
    const heroTitle = document.querySelector('.hero-title');
    const heroDescription = document.querySelector('.hero-description');
    const heroButton = document.querySelector('.hero-button');
    const heroImage = document.querySelector('.hero-image');
    
    if (heroSection) {
        // Создаем ScrollTrigger для hero секции
        gsap.registerPlugin(ScrollTrigger);
        
        // Получаем параметры анимации в зависимости от устройства
        const params = getAnimationParams();
        
        // 1. Анимация изображения (появляется первым)
        if (heroImage) {
            gsap.fromTo(heroImage,
                {
                    x: 100,
                    opacity: 0,
                    scale: 0.8
                },
                {
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    duration: params.duration * 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: heroSection,
                        start: params.scrollTriggerStart,
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 2. Анимация заголовка (появляется вторым)
        if (heroTitle) {
            gsap.fromTo(heroTitle, 
                {
                    y: params.offsetY,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: params.duration,
                    delay: 0.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: heroSection,
                        start: params.scrollTriggerStart,
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 3. Анимация описания (появляется вместе с заголовком)
        if (heroDescription) {
            gsap.fromTo(heroDescription,
                {
                    y: params.offsetYSmall,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.6,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: heroSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 4. Анимация кнопки (появляется последней)
        if (heroButton) {
            gsap.fromTo(heroButton,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1,
                    ease: "power3.out"
                }
            );
        }
        
    }
});

// Features scroll animations
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip GSAP animations on mobile - using AOS instead
    
    const featuresSection = document.querySelector('.features');
    const featuresTitle = document.querySelector('.features-title');
    const featuresImage = document.querySelector('.features-content img');
    const featuresDownload = document.querySelector('.features-download');
    const featuresSliders = document.querySelector('.features-sliders');
    const featuredText = document.querySelector('.featured-text');
    
    if (featuresSection) {
        // Анимация заголовка
        if (featuresTitle) {
            gsap.fromTo(featuresTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: featuresSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация изображения
        if (featuresImage) {
            gsap.fromTo(featuresImage,
                {
                    x: -100,
                    opacity: 0,
                    scale: 0.9
                },
                {
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    duration: 1.56,
                    delay: 0.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: featuresSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация кнопок скачивания
        if (featuresDownload) {
            gsap.fromTo(featuresDownload,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: featuresSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация слайдеров
        if (featuresSliders) {
            gsap.fromTo(featuresSliders,
                {
                    x: 100,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1.56,
                    delay: 0.3,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: featuresSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация текста внизу
        if (featuredText) {
            gsap.fromTo(featuredText,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.6,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: featuresSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
    }
});

// Services scroll animations with slider control
document.addEventListener('DOMContentLoaded', function() {
    console.log('Services Desktop Init - isDesktop:', isDesktop());
    if (!isDesktop()) return; // Skip animations on tablets and mobile
    
    const servicesSection = document.querySelector('.services');
    const servicesTitle = document.querySelector('.services-title');
    const servicesSubtitle = document.querySelector('.services-subtitle-text');
    const servicesSliderElement = document.querySelector('.services-slider');
    
    // Элементы первого слайда
    const firstSlide = document.querySelector('.services-slider-slide:first-child');
    const firstSlideImage = firstSlide ? firstSlide.querySelector('.services-slider-slide-image') : null;
    const firstSlideTitle = firstSlide ? firstSlide.querySelector('.services-slider-slide-title') : null;
    const firstSlideDescription = firstSlide ? firstSlide.querySelector('.services-slider-slide-description') : null;
    const firstSlideList = firstSlide ? firstSlide.querySelector('.services-slider-slide-list') : null;
    const firstSlideButton = firstSlide ? firstSlide.querySelector('.services-slider-slide-button') : null;
    
    if (servicesSection) {
        // 1. Анимация заголовка блока
        if (servicesTitle) {
            gsap.fromTo(servicesTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация подзаголовка
        if (servicesSubtitle) {
            gsap.fromTo(servicesSubtitle,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 2. Анимация картинки первого слайда (справа)
        if (firstSlideImage) {
            gsap.fromTo(firstSlideImage,
                {
                    x: 100,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1.56,
                    delay: 0.5,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 3. Анимация заголовка первого слайда
        if (firstSlideTitle) {
            gsap.fromTo(firstSlideTitle,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 4. Анимация описания первого слайда
        if (firstSlideDescription) {
            gsap.fromTo(firstSlideDescription,
                {
                    y: 40,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }

        // 5. Анимация списка первого слайда
        if (firstSlideList) {
            gsap.fromTo(firstSlideList,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                }
            );
        }
        
        // 5. Анимация кнопки первого слайда (только через opacity, одновременно с title/description)
        if (firstSlideButton) {
            gsap.fromTo(firstSlideButton,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Логика блокировки скролла и переключения слайдов (только на DESKTOP)
        if (servicesSliderElement && servicesSlider && servicesSlider.enabled) {
            const totalSlides = servicesSlider.slides.length;
            
            console.log('Services slider initialized with', totalSlides, 'slides');
            
            // Создаем ScrollTrigger для отслеживания входа в секцию (уменьшена дистанция скролла на 30%)
            ScrollTrigger.create({
                id: 'services-desktop-pin', // Уникальный ID для desktop версии
                trigger: servicesSection,
                start: "top top",
                end: () => `+=${window.innerHeight * (totalSlides + 1) * 0.7}`,
                pin: true,
                scrub: true,
                refreshPriority: 0, // Ниже чем у мобильного (там 1)
                onUpdate: (self) => {
                    const progress = self.progress;
                    const targetSlide = Math.floor(progress * totalSlides);
                    const currentSlide = servicesSlider.activeIndex;
                    
                    // Переключаем слайды на основе прогресса
                    if (targetSlide !== currentSlide && targetSlide < totalSlides) {
                        servicesSlider.slideTo(targetSlide, 500);
                    }
                    
                    console.log('Services progress:', progress.toFixed(2), 'Target slide:', targetSlide, 'Current:', currentSlide);
                }
            });
        }
    }
});

// Services scroll animations for mobile - DISABLED, using AOS instead
document.addEventListener('DOMContentLoaded', function() {
    return; // Disabled - using AOS on mobile
    console.log('Services Mobile Init - isDesktop:', isDesktop(), 'width:', window.innerWidth);
    if (isDesktop()) return; // Only for mobile/tablet
    
    const servicesSection = document.querySelector('.services');
    console.log('Services Mobile - section found:', !!servicesSection);
    const servicesTitle = document.querySelector('.services-title');
    const servicesSubtitle = document.querySelector('.services-subtitle-text');
    
    console.log('Services Mobile - title:', !!servicesTitle, 'subtitle:', !!servicesSubtitle);
    
    // Элементы первого слайда
    const firstSlide = document.querySelector('.services-slider-slide:first-child');
    const firstSlideImage = firstSlide ? firstSlide.querySelector('.services-slider-slide-image') : null;
    const firstSlideTitle = firstSlide ? firstSlide.querySelector('.services-slider-slide-title') : null;
    const firstSlideDescription = firstSlide ? firstSlide.querySelector('.services-slider-slide-description') : null;
    const firstSlideButton = firstSlide ? firstSlide.querySelector('.services-slider-slide-button') : null;
    
    console.log('Services Mobile - firstSlide:', !!firstSlide, 'image:', !!firstSlideImage, 'title:', !!firstSlideTitle);
    
    if (servicesSection) {
        console.log('Services Mobile - starting animations');
        
        // Проверяем что ScrollTrigger зарегистрирован
        gsap.registerPlugin(ScrollTrigger);
        console.log('ScrollTrigger registered:', typeof ScrollTrigger);
        
        // Принудительно обновляем ScrollTrigger после загрузки
        ScrollTrigger.refresh();
        
        // Анимация заголовка блока
        if (servicesTitle) {
            console.log('Services Mobile - animating title');
            
            // Устанавливаем начальное состояние
            gsap.set(servicesTitle, {
                y: (!isDesktop() ? 40 : 80),
                opacity: 0
            });
            
            const animation = gsap.to(servicesTitle, {
                y: 0,
                opacity: 1,
                duration: (!isDesktop() ? 0.9 : 1.3),
                ease: "power3.out",
                scrollTrigger: {
                    trigger: servicesSection,
                    start: (!isDesktop() ? "top 80%" : "top 60%"),
                    end: "bottom 20%",
                    toggleActions: "play none none reverse",
                    once: false,
                    // Важно! Проверяем сразу при создании
                    immediateRender: false,
                    onEnter: () => console.log('Services title animation triggered!')
                }
            });
            console.log('Services title animation created:', !!animation);
        }
        
        // Анимация подзаголовка
        if (servicesSubtitle) {
            gsap.fromTo(servicesSubtitle,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация картинки первого слайда
        if (firstSlideImage) {
            gsap.fromTo(firstSlideImage,
                {
                    x: 100,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1.56,
                    delay: 0.5,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация заголовка и описания первого слайда
        if (firstSlideTitle) {
            gsap.fromTo(firstSlideTitle,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (firstSlideDescription) {
            gsap.fromTo(firstSlideDescription,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация кнопки первого слайда
        if (firstSlideButton) {
            gsap.fromTo(firstSlideButton,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: servicesSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
    }
});

// Testimonials scroll animations
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip GSAP animations on mobile - using AOS instead
    
    const testimonialsSection = document.querySelector('.testimonials');
    const testimonialsTitle = document.querySelector('.testimonials-title');
    const testimonialsSlider = document.querySelector('.testimonials-slider');
    
    if (testimonialsSection) {
        // Анимация заголовка
        if (testimonialsTitle) {
            gsap.fromTo(testimonialsTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: testimonialsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация слайдера
        if (testimonialsSlider) {
            gsap.fromTo(testimonialsSlider,
                {
                    y: 60,
                },
                {
                    y: 0,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.3,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: testimonialsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
    }
});

// Tariffs scroll animations
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip GSAP animations on mobile - using AOS instead
    
    const tariffsSection = document.querySelector('.tariffs');
    const tariffsTitle = document.querySelector('.tariffs-title');
    const tariffsSubtitle = document.querySelector('.tariffs-subtitle-text');
    const tariffsCards = document.querySelectorAll('.tariffs-slider-slide');
    
    if (tariffsSection) {
        // Анимация заголовка
        if (tariffsTitle) {
            gsap.fromTo(tariffsTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: tariffsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }

        if (tariffsSubtitle) {
            gsap.fromTo(tariffsSubtitle, 
                {
                    y: 0,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                }

            );
        }
        
        // Анимация карточек
        if (tariffsCards.length > 0) {
            tariffsCards.forEach((card, index) => {
                const cardImage = card.querySelector('.tariffs-slider-slide-image');
                const cardTop = card.querySelector('.tariffs-slider-slide-top');
                const cardPrice = card.querySelector('.tariffs-slider-slide-price');
                const cardButton = card.querySelector('.tariffs-slider-slide-button');
                
                // 1. Анимация карточки и картинки (вместе) - scale снизу
                // Каждая следующая карточка начинается когда предыдущая на 90% завершена
                const cardAnimDuration = 0.5;
                const overlapDelay = 0.3 + (index * cardAnimDuration * 0.9);
                
                gsap.fromTo(card,
                    {
                        y: 80,
                        scale: 0.8,
                        opacity: 0
                    },
                    {
                        y: 0,
                        scale: 1,
                        opacity: 1,
                        duration: cardAnimDuration,
                        delay: overlapDelay,
                        ease: "back.out(1.4)",
                        scrollTrigger: {
                            trigger: tariffsSection,
                            start: (!isDesktop() ? "top 80%" : "top 60%"),
                            end: "bottom 20%",
                            toggleActions: "play none none reverse"
                        }
                    }
                );
                
                // 2. Анимация контента внутри карточки
                // Title (только заголовок, без кнопки)
                const cardTitle = card.querySelector('.tariffs-slider-slide-title');
                if (cardTitle) {
                    gsap.fromTo(cardTitle,
                        {
                            opacity: 0,
                            y: 20
                        },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.6,
                            delay: overlapDelay + 0.2,
                            ease: "power3.out",
                            scrollTrigger: {
                                trigger: tariffsSection,
                                start: (!isDesktop() ? "top 80%" : "top 60%"),
                                end: "bottom 20%",
                                toggleActions: "play none none reverse"
                            }
                        }
                    );
                }
                
                // Open button
                const cardOpenButton = card.querySelector('.tariffs-slider-slide-open');
                if (cardOpenButton) {
                    gsap.fromTo(cardOpenButton,
                        {
                            opacity: 0
                        },
                        {
                            opacity: 1,
                            duration: 0.6,
                            delay: overlapDelay + 0.2,
                            ease: "power3.out",
                            scrollTrigger: {
                                trigger: tariffsSection,
                                start: (!isDesktop() ? "top 80%" : "top 60%"),
                                end: "bottom 20%",
                                toggleActions: "play none none reverse"
                            }
                        }
                    );
                }
                
                // Price
                if (cardPrice) {
                    gsap.fromTo(cardPrice,
                        {
                            opacity: 0,
                            y: 20
                        },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.6,
                            delay: overlapDelay + 0.35,
                            ease: "power3.out",
                            scrollTrigger: {
                                trigger: tariffsSection,
                                start: (!isDesktop() ? "top 80%" : "top 60%"),
                                end: "bottom 20%",
                                toggleActions: "play none none reverse"
                            }
                        }
                    );
                }
                
                // Button
                if (cardButton) {
                    gsap.fromTo(cardButton,
                        {
                            opacity: 0,
                            y: 20
                        },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.6,
                            delay: overlapDelay + 0.5,
                            ease: "power3.out",
                            scrollTrigger: {
                                trigger: tariffsSection,
                                start: (!isDesktop() ? "top 80%" : "top 60%"),
                                end: "bottom 20%",
                                toggleActions: "play none none reverse"
                            }
                        }
                    );
                }
            });
        }
    }
});

// Steps scroll animations with slider control
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip animations on tablets and mobile
    
    const stepsSection = document.querySelector('.steps');
    const stepsTitle = document.querySelector('.steps-title');
    const stepsSliderElement = document.querySelector('.steps-slider');
    
    // Элементы первого слайда
    const firstSlide = document.querySelector('.steps-slider-slide:first-child');
    const firstSlideImage = firstSlide ? firstSlide.querySelector('.steps-slider-slide-image') : null;
    const firstSlideNumber = firstSlide ? firstSlide.querySelector('.steps-slider-slide-number') : null;
    const firstSlideTitle = firstSlide ? firstSlide.querySelector('.steps-slider-slide-title') : null;
    const firstSlideDescription = firstSlide ? firstSlide.querySelector('.steps-slider-slide-description') : null;
    const firstSlideButtons = firstSlide ? firstSlide.querySelector('.steps-slider-slide-buttons') : null;
    
    if (stepsSection) {
        // 1. Анимация заголовка блока
        if (stepsTitle) {
            gsap.fromTo(stepsTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 2. Анимация картинки первого слайда (слева)
        if (firstSlideImage) {
            gsap.fromTo(firstSlideImage,
                {
                    x: -100,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1.56,
                    delay: 0.3,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 3. Анимация номера первого слайда
        if (firstSlideNumber) {
            gsap.fromTo(firstSlideNumber,
                {
                    scale: 0,
                    opacity: 0
                },
                {
                    scale: 1,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.6,
                    ease: "back.out(1.7)",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 4. Анимация заголовка первого слайда
        if (firstSlideTitle) {
            gsap.fromTo(firstSlideTitle,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 5. Анимация описания первого слайда
        if (firstSlideDescription) {
            gsap.fromTo(firstSlideDescription,
                {
                    y: 40,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 6. Анимация кнопок первого слайда
        if (firstSlideButtons) {
            gsap.fromTo(firstSlideButtons,
                {
                    y: 30,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Логика блокировки скролла и переключения слайдов
        if (stepsSliderElement && stepsSlider) {
            const totalSlides = stepsSlider.slides.length;
            
            console.log('Steps slider initialized with', totalSlides, 'slides');
            
            // Создаем ScrollTrigger для отслеживания входа в секцию (уменьшена дистанция скролла на 30%)
            ScrollTrigger.create({
                trigger: stepsSection,
                start: "top top",
                end: () => `+=${window.innerHeight * (totalSlides + 1) * 0.7}`,
                pin: true,
                scrub: true,
                onUpdate: (self) => {
                    const progress = self.progress;
                    const targetSlide = Math.floor(progress * totalSlides);
                    const currentSlide = stepsSlider.activeIndex;
                    
                    // Переключаем слайды на основе прогресса
                    if (targetSlide !== currentSlide && targetSlide < totalSlides) {
                        stepsSlider.slideTo(targetSlide, 500);
                    }
                    
                    console.log('Steps progress:', progress.toFixed(2), 'Target slide:', targetSlide, 'Current:', currentSlide);
                }
            });
        }
    }
});

// Steps scroll animations for mobile - DISABLED, using AOS instead
document.addEventListener('DOMContentLoaded', function() {
    return; // Disabled - using AOS on mobile
    console.log('Steps Mobile Init - isDesktop:', isDesktop(), 'width:', window.innerWidth);
    if (isDesktop()) return; // Only for mobile/tablet
    
    const stepsSection = document.querySelector('.steps');
    console.log('Steps Mobile - section found:', !!stepsSection);
    const stepsTitle = document.querySelector('.steps-title');
    
    // Элементы первого слайда
    const firstSlide = document.querySelector('.steps-slider-slide:first-child');
    const firstSlideImage = firstSlide ? firstSlide.querySelector('.steps-slider-slide-image') : null;
    const firstSlideNumber = firstSlide ? firstSlide.querySelector('.steps-slider-slide-number') : null;
    const firstSlideTitle = firstSlide ? firstSlide.querySelector('.steps-slider-slide-title') : null;
    const firstSlideDescription = firstSlide ? firstSlide.querySelector('.steps-slider-slide-description') : null;
    const firstSlideButtons = firstSlide ? firstSlide.querySelector('.steps-slider-slide-buttons') : null;
    
    if (stepsSection) {
        // Анимация заголовка блока
        if (stepsTitle) {
            gsap.fromTo(stepsTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация картинки первого слайда
        if (firstSlideImage) {
            gsap.fromTo(firstSlideImage,
                {
                    x: -100,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1.56,
                    delay: 0.3,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация номера слайда
        if (firstSlideNumber) {
            gsap.fromTo(firstSlideNumber,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.6,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация заголовка слайда
        if (firstSlideTitle) {
            gsap.fromTo(firstSlideTitle,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.9,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация описания слайда
        if (firstSlideDescription) {
            gsap.fromTo(firstSlideDescription,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // Анимация кнопок слайда
        if (firstSlideButtons) {
            gsap.fromTo(firstSlideButtons,
                {
                    y: (!isDesktop() ? 30 : 60),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1.5,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: stepsSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
    }
});

// FAQ scroll animations
document.addEventListener('DOMContentLoaded', function() {
    if (!isDesktop()) return; // Skip GSAP animations on mobile - using AOS instead
    
    const faqSection = document.querySelector('.faq');
    const faqTitle = document.querySelector('.faq-title');
    const faqDescription = document.querySelector('.faq-description');
    const faqButton = document.querySelector('.faq-button');
    const faqAccordionItems = document.querySelectorAll('.faq-accordion-item');
    
    if (faqSection) {
        // 1. Анимация заголовка
        if (faqTitle) {
            gsap.fromTo(faqTitle, 
                {
                    y: (!isDesktop() ? 40 : 80),
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: faqSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 2. Анимация описания
        if (faqDescription) {
            gsap.fromTo(faqDescription,
                {
                    x: -50,
                    opacity: 0
                },
                {
                    x: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.3,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: faqSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 3. Анимация кнопки
        if (faqButton) {
            gsap.fromTo(faqButton,
                {
                    y: 30,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.6,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: faqSection,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        // 4. Анимация аккордеон айтемов (последовательно)
        if (faqAccordionItems.length > 0) {
            faqAccordionItems.forEach((item, index) => {
                gsap.fromTo(item,
                    {
                        x: 50,
                        opacity: 0
                    },
                    {
                        x: 0,
                        opacity: 1,
                        duration: (!isDesktop() ? 0.7 : 1.04),
                        delay: 0.3 + (index * 0.1),
                        ease: "power3.out",
                        scrollTrigger: {
                            trigger: faqSection,
                            start: (!isDesktop() ? "top 80%" : "top 60%"),
                            end: "bottom 20%",
                            toggleActions: "play none none reverse"
                        }
                    }
                );
            });
        }
    }
});

// Footer scroll animations with marquee effect
document.addEventListener('DOMContentLoaded', function() {  
    const footer = document.querySelector('.footer');
    const footerTitleWrapper = document.querySelector('.footer-title');
    const footerDownloads = document.querySelector('.footer-downloads');
    const footerNav = document.querySelector('.footer-nav');
    const footerSocial = document.querySelector('.footer-social-wrapper');
    const footerEmail = document.querySelector('.footer-email');
    const footerSubnav = document.querySelector('.footer-subnav');
    const footerCopyright = document.querySelector('.footer-copyright');
    
    if (footer) {
        // Анимация элементов footer (только на desktop, на mobile используется AOS)
        if (isDesktop() && footerDownloads) {
            gsap.fromTo(footerDownloads,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (isDesktop() && footerNav) {
            gsap.fromTo(footerNav,
                {
                    y: 50,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.9 : 1.3),
                    delay: 0.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (isDesktop() && footerSocial) {
            gsap.fromTo(footerSocial,
                {
                    y: 30,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (isDesktop() && footerEmail) {
            gsap.fromTo(footerEmail,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.6,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (isDesktop() && footerSubnav) {
            gsap.fromTo(footerSubnav,
                {
                    y: 20,
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 0.8,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }
        
        if (isDesktop() && footerCopyright) {
            gsap.fromTo(footerCopyright,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: (!isDesktop() ? 0.7 : 1.04),
                    delay: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: footer,
                        start: (!isDesktop() ? "top 80%" : "top 60%"),
                        end: "bottom 20%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }

        if(footerTitleWrapper) {
            const originalImage = footerTitleWrapper.querySelector('img');

            const numberOfCopies = 5;
            for (let i = 0; i < numberOfCopies; i++) {
                const clone = originalImage.cloneNode(true);
                footerTitleWrapper.appendChild(clone);
            }
            
            // Настраиваем стили для marquee
            footerTitleWrapper.style.display = 'flex';
            footerTitleWrapper.style.gap = '40px';
            footerTitleWrapper.style.width = 'max-content';
            footerTitleWrapper.style.position = 'absolute';
            footerTitleWrapper.style.top = '10px';
            footerTitleWrapper.style.left = '0';
            footerTitleWrapper.style.transform = 'translate3d(0, 0, 0)';
            footerTitleWrapper.style.overflow = 'hidden';
            footerTitleWrapper.style.whiteSpace = 'nowrap';
            footerTitleWrapper.style.willChange = 'transform';
            footerTitleWrapper.style.backfaceVisibility = 'hidden';
            
            // Устанавливаем родительский контейнер с overflow hidden
            const parentContainer = footerTitleWrapper.parentElement;
            if (parentContainer) {
                parentContainer.style.overflow = 'hidden';
                parentContainer.style.position = 'relative';
            }
            
            // Создаем бесконечную анимацию
            const totalWidth = footerTitleWrapper.scrollWidth / (numberOfCopies + 1);
            gsap.to(footerTitleWrapper, {
                x: -1440,
                duration: 20,
                ease: "none",
                repeat: -1,
                force3D: true,
                modifiers: {
                    x: function(x) {
                        return (parseFloat(x) % totalWidth) + "px";
                    }
                }
            });       
        }
    }
});

window.addEventListener('load', function() {
    console.log('Page fully loaded - refreshing ScrollTrigger');
    if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
        console.log('ScrollTrigger refreshed');
    }
});

const languageSwitcher = document.querySelector('.language-button');
if (languageSwitcher) {
    languageSwitcher.addEventListener('click', function() {
        const languageList = document.querySelector('.language-list');
        if (languageList.classList.contains('active')) {
            languageList.classList.remove('active');
        } else {
            languageList.classList.add('active');
        }
    });
}